import { combineReducers } from "utils";

import companyAssets from "./asset";
import company from "./company";
import contact from "./contact";
import incentive from "./incentive";
import portfolio from "./portfolio";

export default combineReducers({
  company,
  contact,
  incentive,
  portfolio,
  companyAssets,
});
